import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['provider', 'baseModel', 'options']

  connect() {
    this.optionsByProvider = JSON.parse(this.optionsTarget.value || '{}')
    this.updateBases()
  }

  updateBases() {
    const provider = this.providerTarget.value
    const bases = this.optionsByProvider[provider] || []
    this.baseModelTarget.innerHTML = ''
    bases.forEach((id) => {
      const option = document.createElement('option')
      option.value = id
      option.textContent = id
      this.baseModelTarget.appendChild(option)
    })
  }
}
